module.exports = __webpack_public_path__ + "img/spot-3.76a4a85a.png";